<script>
    export let rotate = 0;
</script>

<svg
  class="dropdown-arrow"
  width="13"
  height="13"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style="transform: rotate({rotate}deg);"
>
  <path
    d="M2 5L8 11L14 5"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<style>
  .dropdown-arrow {
    margin-left: auto;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
